import React from 'react';

import styles from './styles.module.css';

interface LoadingIndicatorProps {
  text?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ text }) => (
  <div className={styles.container} data-testid="loading-indicator">
    <svg className={styles.spinner} width="88px" height="88px" viewBox="0 0 88 88" xmlns="http://www.w3.org/2000/svg">
      <circle stroke="#F2F2F2" fill="none" strokeWidth="4" strokeLinecap="square" cx="44" cy="44" r="40" />
      <circle className={styles.path} fill="none" strokeWidth="4" strokeLinecap="square" cx="44" cy="44" r="40" />
    </svg>
    {text && <div className={styles.text}>{text}</div>}
  </div>
);

export default LoadingIndicator;
